// https://webpack.js.org/guides/public-path/#on-the-fly
__webpack_public_path__ = __webpack_public_path__.replace(
    '/webpack/public/path/',
    `${window.CDN_URL}/js/`
);
